// extracted by mini-css-extract-plugin
export var details = "_dv-0";
export var inspectorPopover = "_dv-1";